import { enqueueSnackbar } from 'notistack';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Button from '@/components/Button/Button';
import CustomImage from '@/components/CustomImage';
import { useFormatText } from '@/hooks/useFormatText';
import { resendPasswordLink } from '@/service/authService';

const LinkExpired = ({ token }: { token: string | null }) => {
  const { formatText } = useFormatText();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (!token) {
      return;
    }
    setLoading(true);
    try {
      const payload: { token: string } = {
        token,
      };

      const response = await resendPasswordLink(payload);

      if (response?.status) {
        enqueueSnackbar(response?.message, { variant: 'success' });
        const email = response?.data?.email;
        navigate('/check-email', { state: { email } });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col justify-center p-15 md:p-10 w-full lg:max-w-150">
      <div className="w-full h-full flex flex-col items-center my-auto space-y-10">
        <div>
          <p className="pb-2 text-center leading-[-0.36px] text-4xl max-md:text-3xl font-bold text-neutral-primary">
            {formatText('link-expired.title')}
          </p>
          <div className="text-neutral-secondary text-center text-lg font-medium">
            {formatText('link-expired.sub-title')}{' '}
          </div>
        </div>
        <CustomImage
          src={'/assets/svg/link-expired.svg'}
          alt={'Link Expired'}
          className="w-25 h-25"
        />
        <Button
          label={formatText('link-expired.actions.resend-link')}
          variant="primary"
          className="w-full py-3.5! leading-5"
          onClick={handleClick}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default LinkExpired;
